import { ATTR_NAMES_LEAD } from '~/src/models/constants/attr-names-lead.constants';

export const placeholders = {
    contactFio: 'Фамилия Имя',
    email: 'Email',
    workEmail: 'Рабочий email',
    phone: '+7',
    selfEmployedInn: '12 цифр',
    selfEmployedFio: 'Фамилия Имя Отчество',
};

export const titles = {
    contactFio: 'Ваше имя',
    email: 'Email',
    workEmail: 'Ваш рабочий email',
    phone: 'Контактный телефон',
    selfEmployedFio: 'ФИО клиента',
    selfEmployedInn: 'ИНН',
};

export const initialCreateLeadDataContactFio = {
    [ATTR_NAMES_LEAD.contactFio]: false,
    analyticsWasSend: false,
};

export const initialCreateLeadDataPhoneNumber = {
    [ATTR_NAMES_LEAD.phoneNumber]: false,
    analyticsWasSend: false,
};

export const initialCreateLeadDataEmail = {
    [ATTR_NAMES_LEAD.email]: false,
    analyticsWasSend: false,
};
